import { normalizeSiteLanguage, type SiteLanguage } from './routing';

const APP_TLD_BY_LANG: Record<SiteLanguage, string> = {
  sk: 'sk',
  cs: 'cz',
  da: 'dk',
  en: 'com',
  de: 'de',
};

export const APP_LEGAL_ORIGINS = [
  'https://app.bidmio.sk',
  'https://app.bidmio.cz',
  'https://app.bidmio.dk',
  'https://app.bidmio.com',
  'https://app.bidmio.de',
] as const;

export function appLegalOrigin(lang?: string | null): string {
  const tld = APP_TLD_BY_LANG[normalizeSiteLanguage(lang)];
  return `https://app.bidmio.${tld}`;
}

export function appLegalUrl(lang: string | null | undefined, path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${appLegalOrigin(lang)}${normalized}`;
}

/** Public ERP booking page for a Bidmio demo (same ccTLD as the marketing host). */
export const BOOK_DEMO_PATH = '/book/demo';

export function appBookDemoUrl(lang?: string | null): string {
  return appLegalUrl(lang, BOOK_DEMO_PATH);
}

export function isAppLegalOrigin(origin: string): boolean {
  return (APP_LEGAL_ORIGINS as readonly string[]).includes(origin);
}
